var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74703 12.8183C9.83042 12.8183 12.33 10.3187 12.33 7.23531C12.33 4.15192 9.83042 1.65234 6.74703 1.65234C3.66364 1.65234 1.16406 4.15192 1.16406 7.23531C1.16406 10.3187 3.66364 12.8183 6.74703 12.8183Z",
    fill: "#E57E03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35503 11.6761L3.36145 11.6697C3.33791 11.6526 3.31437 11.6333 3.29297 11.6162L3.35503 11.6761Z",
    fill: "#BF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01229 12.1042L4.01015 12.102C3.99304 12.0935 3.97592 12.0828 3.96094 12.0742L4.01871 12.1277L4.03155 12.1127C4.02299 12.1106 4.01871 12.1063 4.01229 12.1042Z",
    fill: "#BF5F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01384 12.1037C4.01384 12.1016 4.01172 12.1016 4.01172 12.1016L4.01384 12.1037Z",
    fill: "#FFF35A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77646 11.1024L2.65234 10.9847L4.57396 8.95605L4.65314 9.03095L4.6617 9.02025L4.6938 9.05021L4.68524 9.06091L4.69808 9.07375L2.77646 11.1024Z",
    fill: "#FFF35A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2616 9.63513L3.34854 11.653L3.31644 11.6231L5.2295 9.60517L5.15032 9.53027L3.22656 11.5589L3.28862 11.6167C3.31216 11.6338 3.33356 11.653 3.3571 11.6702L5.27443 9.64797L5.2616 9.63513Z",
    fill: "#BF5F00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77432 11.0788L2.74222 11.051L4.65528 9.03095L4.5761 8.95605L2.65234 10.9847L2.77646 11.1024L4.70022 9.07375L4.68524 9.06091L2.77432 11.0788Z",
    fill: "#BF5F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.083 8.45771L4.00382 8.38281L2.125 10.3643C2.1464 10.3943 2.1678 10.4264 2.1892 10.4564L4.083 8.45771Z",
    fill: "#BF5F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11116 8.4873L2.21094 10.4924C2.21522 10.4967 2.21736 10.5031 2.22164 10.5074L4.124 8.50014L4.11116 8.4873Z",
    fill: "#FFF35A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50705 7.88349L3.42787 7.80859L1.70312 9.62964C1.72024 9.66602 1.73736 9.70025 1.75448 9.73449L3.50705 7.88349Z",
    fill: "#BF5F00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54061 7.91406L1.77734 9.77576C1.77948 9.78218 1.78376 9.78646 1.7859 9.79288L3.55345 7.9269L3.54061 7.91406Z",
    fill: "#FFF35A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96752 7.33887L1.4375 8.95234C1.43964 8.95876 1.44178 8.96518 1.44392 8.9716L2.98036 7.34957L2.96752 7.33887Z",
    fill: "#FFF35A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93209 7.31122L2.85292 7.23633L1.38281 8.78775C1.39351 8.8284 1.40635 8.86906 1.41919 8.90972L2.93209 7.31122Z",
    fill: "#BF5F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35941 6.73408L2.28024 6.65918L1.19531 7.80402C1.19959 7.8511 1.20601 7.90031 1.21243 7.94739L2.35941 6.73408Z",
    fill: "#BF5F00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39141 6.76465L1.21875 8.0015C1.21875 8.01006 1.22089 8.01648 1.22303 8.02504L2.40639 6.77749L2.39141 6.76465Z",
    fill: "#FFF35A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78704 6.16083L1.70787 6.08594L1.20071 6.62091C1.19429 6.68083 1.18787 6.7386 1.18359 6.79852L1.78704 6.16083Z",
    fill: "#BF5F00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81561 6.19141L1.17792 6.86547C1.17792 6.87403 1.17578 6.88473 1.17578 6.89329L1.83059 6.20425L1.81561 6.19141Z",
    fill: "#FFF35A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09353 4.05176L1.33668 5.85782C1.33454 5.87066 1.33026 5.88136 1.32812 5.8942L3.10637 4.0646L3.09353 4.05176Z",
    fill: "#FFF35A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06272 4.02137L2.98355 3.94434L1.42571 5.54711C1.40217 5.62201 1.38077 5.6969 1.35938 5.7718L3.06272 4.02137Z",
    fill: "#BF5F00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06162 3.29579L2.98244 3.21875L2.12863 4.0961C2.03447 4.2352 1.94674 4.37857 1.86328 4.52622L3.06162 3.29579Z",
    fill: "#BF5F00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09096 3.32617L1.78777 4.66574C1.77707 4.685 1.76851 4.70426 1.75781 4.72138L3.10166 3.33901L3.09096 3.32617Z",
    fill: "#FFF35A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92478 10.0859L4.01172 12.1039C4.01814 12.106 4.02242 12.1103 4.02884 12.1124L5.93762 10.0966L5.92478 10.0859Z",
    fill: "#FFF35A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98227 12.0733L5.89533 10.0554L5.81615 9.98047L3.89453 12.0091L3.96301 12.0733C3.98013 12.0818 3.99725 12.0925 4.01223 12.1011L3.98227 12.0733Z",
    fill: "#BF5F00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59448 10.5352L4.77344 12.4568C4.77986 12.4589 4.78628 12.4611 4.7927 12.4632L6.60732 10.548L6.59448 10.5352Z",
    fill: "#FFF35A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5602 10.5056L6.48103 10.4307L4.61719 12.3972C4.65357 12.4122 4.68994 12.4272 4.72632 12.4422L6.5602 10.5056Z",
    fill: "#BF5F00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22495 10.9567L7.14578 10.8818L5.45312 12.6686C5.49378 12.6793 5.53658 12.6879 5.57724 12.6965L7.22495 10.9567Z",
    fill: "#BF5F00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26127 10.9844L5.63281 12.7048C5.63923 12.707 5.64779 12.707 5.65421 12.7091L7.27625 10.9972L7.26127 10.9844Z",
    fill: "#FFF35A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92466 11.4355L6.61719 12.8158C6.62575 12.8158 6.63431 12.8158 6.64287 12.8158L7.93964 11.4484L7.92466 11.4355Z",
    fill: "#FFF35A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89272 11.406L7.81355 11.3311L6.41406 12.8076C6.46328 12.8097 6.51036 12.8119 6.55958 12.814L7.89272 11.406Z",
    fill: "#BF5F00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58826 11.8857L7.80078 12.7182C7.81148 12.716 7.82218 12.7139 7.83074 12.7117L8.6011 11.8986L8.58826 11.8857Z",
    fill: "#FFF35A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55476 11.8581L8.47559 11.7832L7.54688 12.7633C7.60679 12.7547 7.66671 12.7462 7.72449 12.7355L8.55476 11.8581Z",
    fill: "#BF5F00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32049 11.8581L9.24132 11.7832L8.53516 12.5279C8.61219 12.5022 8.68923 12.4744 8.76626 12.4444L9.32049 11.8581Z",
    fill: "#BF5F00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34941 11.8857L8.85938 12.4036C8.87221 12.3972 8.88719 12.3929 8.90003 12.3865L9.36225 11.8986L9.34941 11.8857Z",
    fill: "#FFF35A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23539 9.59713L5.22656 9.60645L5.25763 9.63588L5.26646 9.62656L5.23539 9.59713Z",
    fill: "#FFF35A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22977 9.60468L3.31641 11.624L3.34747 11.6535L5.26083 9.63411L5.22977 9.60468Z",
    fill: "#FFF35A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66508 9.02291L4.65625 9.03223L4.68732 9.06166L4.69615 9.05234L4.66508 9.02291Z",
    fill: "#FFF35A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65555 9.03143L2.74219 11.0508L2.77325 11.0802L4.68661 9.06087L4.65555 9.03143Z",
    fill: "#FFF35A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09086 8.44869L4.08203 8.45801L4.1131 8.48744L4.12193 8.47812L4.09086 8.44869Z",
    fill: "#FFF35A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21318 10.4921L4.1134 8.48699L4.0813 8.45703L2.1875 10.4557C2.19606 10.4685 2.20462 10.4792 2.21318 10.4921Z",
    fill: "#FFF35A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51664 7.87349L3.50781 7.88281L3.53888 7.91225L3.54771 7.90293L3.51664 7.87349Z",
    fill: "#FFF35A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77531 9.7735L3.53857 7.91179L3.50647 7.88184L1.75391 9.73284C1.76033 9.74782 1.76889 9.76066 1.77531 9.7735Z",
    fill: "#FFF35A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94242 7.30025L2.93359 7.30957L2.96466 7.33901L2.97349 7.32969L2.94242 7.30025Z",
    fill: "#FFF35A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43685 8.95398L2.96687 7.34051L2.93478 7.31055L1.42188 8.9069C1.42615 8.92188 1.43257 8.93686 1.43685 8.95398Z",
    fill: "#FFF35A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36821 6.72798L2.35938 6.7373L2.39044 6.76674L2.39927 6.75742L2.36821 6.72798Z",
    fill: "#FFF35A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2195 8.00119L2.39216 6.76433L2.36006 6.73438L1.21094 7.94769C1.21308 7.96481 1.21522 7.98407 1.2195 8.00119Z",
    fill: "#FFF35A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79399 6.15181L1.78516 6.16113L1.81622 6.19057L1.82505 6.18125L1.79399 6.15181Z",
    fill: "#FFF35A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17969 6.86516L1.81737 6.19109L1.78528 6.16113L1.18397 6.79668C1.18183 6.82022 1.18183 6.84162 1.17969 6.86516Z",
    fill: "#FFF35A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07294 4.01075L3.0625 4.02148L3.09318 4.05133L3.10362 4.04059L3.07294 4.01075Z",
    fill: "#FFF35A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 5.85751L3.09279 4.05144L3.06283 4.02148L1.35948 5.77405C1.35092 5.79973 1.3445 5.82969 1.33594 5.85751Z",
    fill: "#FFF35A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07294 3.28614L3.0625 3.29688L3.09318 3.32672L3.10362 3.31598L3.07294 3.28614Z",
    fill: "#FFF35A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79297 4.66543L3.09616 3.32586L3.0662 3.2959L1.86786 4.52633C1.84005 4.57341 1.81651 4.61835 1.79297 4.66543Z",
    fill: "#FFF35A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90336 10.0473L5.89453 10.0566L5.9256 10.0861L5.93443 10.0768L5.90336 10.0473Z",
    fill: "#FFF35A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00829 12.1024C4.01043 12.1024 4.01043 12.1045 4.01257 12.1045L5.92563 10.0866L5.89353 10.0566L3.98047 12.0746L4.00829 12.1024Z",
    fill: "#FFF35A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57133 10.4975L6.5625 10.5068L6.59357 10.5363L6.6024 10.527L6.57133 10.4975Z",
    fill: "#FFF35A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7715 12.4565L6.59254 10.5348L6.56045 10.5049L4.72656 12.4393C4.74154 12.4458 4.75652 12.4522 4.7715 12.4565Z",
    fill: "#FFF35A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23149 10.9477L7.22266 10.957L7.25372 10.9865L7.26255 10.9771L7.23149 10.9477Z",
    fill: "#FFF35A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62948 12.7055L7.25794 10.985L7.22584 10.9551L5.57812 12.6927C5.59738 12.6991 5.6145 12.7034 5.62948 12.7055Z",
    fill: "#FFF35A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89946 11.3979L7.89062 11.4072L7.92169 11.4367L7.93052 11.4273L7.89946 11.3979Z",
    fill: "#FFF35A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62028 12.8164L7.92775 11.4362L7.89565 11.4062L6.5625 12.8143C6.58176 12.8143 6.60102 12.8164 6.62028 12.8164Z",
    fill: "#FFF35A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56742 11.8481L8.55859 11.8574L8.58966 11.8869L8.59849 11.8775L8.56742 11.8481Z",
    fill: "#FFF35A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80146 12.7178L8.58894 11.8854L8.55684 11.8555L7.72656 12.7307C7.75438 12.7285 7.77792 12.7221 7.80146 12.7178Z",
    fill: "#FFF35A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32914 11.8461L9.32031 11.8555L9.35138 11.8849L9.36021 11.8756L9.32914 11.8461Z",
    fill: "#FFF35A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86192 12.4033L9.35195 11.8854L9.31986 11.8555L8.76562 12.4397C8.79986 12.429 8.82982 12.4161 8.86192 12.4033Z",
    fill: "#FFF35A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25093 12.3905C10.3343 12.3905 12.8339 9.89096 12.8339 6.80757C12.8339 3.72419 10.3343 1.22461 7.25093 1.22461C4.16755 1.22461 1.66797 3.72419 1.66797 6.80757C1.66797 9.89096 4.16755 12.3905 7.25093 12.3905Z",
    fill: "#FFBC00"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24999 1.22461C5.70286 1.22461 4.30123 1.85588 3.28906 2.87232C4.26485 2.03991 5.52952 1.53703 6.91189 1.53703C9.99547 1.53703 12.4949 4.03642 12.4949 7.12C12.4949 8.6543 11.8764 10.0452 10.8728 11.0531C12.0712 10.0302 12.8308 8.50665 12.8308 6.80757C12.833 3.724 10.3336 1.22461 7.24999 1.22461Z",
    fill: "#FFF35A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21363 11.3511C9.70256 11.3511 11.7202 9.33342 11.7202 6.84449C11.7202 4.35557 9.70256 2.33789 7.21363 2.33789C4.72471 2.33789 2.70703 4.35557 2.70703 6.84449C2.70703 9.33342 4.72471 11.3511 7.21363 11.3511Z",
    fill: "#FFAA00"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24879 2.41945C7.84154 2.41945 8.41503 2.53501 8.95642 2.76397C9.47855 2.98438 9.94933 3.30109 10.3516 3.70552C10.7539 4.10782 11.0706 4.5786 11.2932 5.10073C11.5221 5.64212 11.6377 6.21561 11.6377 6.80836C11.6377 7.40111 11.5221 7.9746 11.2932 8.51599C11.0728 9.03812 10.7561 9.5089 10.3516 9.9112C9.94933 10.3135 9.47855 10.6302 8.95642 10.8527C8.41503 11.0817 7.84154 11.1973 7.24879 11.1973C6.65604 11.1973 6.08255 11.0817 5.54116 10.8527C5.01903 10.6323 4.54825 10.3156 4.14595 9.9112C3.74365 9.5089 3.42695 9.03812 3.2044 8.51599C2.97544 7.9746 2.85988 7.40111 2.85988 6.80836C2.85988 6.21561 2.97544 5.64212 3.2044 5.10073C3.42481 4.5786 3.74151 4.10782 4.14595 3.70552C4.54825 3.30323 5.01903 2.98652 5.54116 2.76397C6.08255 2.53501 6.65604 2.41945 7.24879 2.41945ZM7.24879 2.30176C4.7601 2.30176 2.74219 4.31967 2.74219 6.80836C2.74219 9.29705 4.7601 11.315 7.24879 11.315C9.73748 11.315 11.7575 9.29705 11.7575 6.80836C11.7575 4.31967 9.73962 2.30176 7.24879 2.30176Z",
    fill: "#FF9100"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21363 2.38729C7.81494 2.38729 8.39913 2.50499 8.94908 2.73824C9.47977 2.96292 9.95697 3.28391 10.3657 3.69263C10.7744 4.10134 11.0954 4.57854 11.3201 5.10923C11.5533 5.65918 11.671 6.24123 11.671 6.84468C11.671 7.44599 11.5533 8.03018 11.3201 8.58013C11.0954 9.11082 10.7744 9.58801 10.3657 9.99673C9.95697 10.4055 9.47977 10.7264 8.94908 10.9511C8.39913 11.1844 7.81708 11.3021 7.21363 11.3021C6.61232 11.3021 6.02814 11.1844 5.47819 10.9511C4.94749 10.7264 4.4703 10.4055 4.06158 9.99673C3.65286 9.58801 3.33188 9.11082 3.10719 8.58013C2.87394 8.03018 2.75625 7.44813 2.75625 6.84468C2.75625 6.24337 2.87394 5.65918 3.10719 5.10923C3.33188 4.57854 3.65286 4.10134 4.06158 3.69263C4.4703 3.28391 4.94749 2.96292 5.47819 2.73824C6.02814 2.50499 6.61232 2.38729 7.21363 2.38729ZM7.21363 2.33594C4.72494 2.33594 2.70703 4.35385 2.70703 6.84254C2.70703 9.33123 4.72494 11.3491 7.21363 11.3491C9.70232 11.3491 11.7224 9.33337 11.7224 6.84468C11.7224 4.35385 9.70232 2.33594 7.21363 2.33594Z",
    fill: "#E57E03"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33984 2.28613C9.79643 2.28613 11.7887 4.30405 11.7887 6.79274C11.7887 8.62662 10.708 10.2037 9.15661 10.9077",
    stroke: "#FFCB57",
    strokeWidth: 0.0168645,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74949 4.49512H5.30078V5.94382H6.74949V4.49512Z",
    fill: "#E57E03"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74949 7.39453H5.30078V8.84324H6.74949V7.39453Z",
    fill: "#E57E03"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1987 5.94531H6.75V7.39402H8.1987V5.94531Z",
    fill: "#E57E03"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64792 7.39453H8.19922V8.84324H9.64792V7.39453Z",
    fill: "#E57E03"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35251 4.81414L5.29688 4.49529L5.44239 4.39258L5.94312 5.4133L5.35251 4.81414Z",
    fill: "#E57E03"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74667 5.94622L6.69531 5.73438L6.89004 5.84137L6.96494 7.04185L8.33875 7.29007L8.52492 7.75443L8.26385 7.66669L8.19537 7.39493H7.9878L6.82585 7.25156L6.74667 5.94622Z",
    fill: "#E57E03"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48023 8.8436H6.74772L6.89109 8.74088L5.66494 7.81431L5.44239 7.29004L5.29688 7.39489L5.36107 8.66385L6.48023 8.8436Z",
    fill: "#E57E03"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79202 8.74105L9.6465 8.84376H9.15219L8.52734 8.01562L9.79202 8.74105Z",
    fill: "#E57E03"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8862 4.39453H5.4375V5.84323H6.8862V4.39453Z",
    fill: "#FFD400"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8862 7.29102H5.4375V8.73972H6.8862V7.29102Z",
    fill: "#FFD400"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78627 5.84277H6.88672V7.29148H9.78627V5.84277Z",
    fill: "#FFD400"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78464 7.29102H8.33594V8.73972H9.78464V7.29102Z",
    fill: "#FFD400"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83019 4.44608V5.84128H6.89011V4.39258H5.44141V4.44608H6.83019Z",
    fill: "#FFF35A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73026 5.89529V7.2905H9.79017V5.8418H6.89062V5.89529H9.73026Z",
    fill: "#FFF35A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7287 7.34354V8.74088H9.78862V7.29004H9.72656V7.34354H9.7287Z",
    fill: "#FFF35A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 8.02206V8.74106H6.88804V7.9707L6.82812 8.02206Z",
    fill: "#FFF35A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperCoin);
export default __webpack_public_path__ + "static/media/hyper-coin.803d824ed1358f59e398bbd7842c7a6a.svg";
export { ForwardRef as ReactComponent };